import React from 'react';
import ReactDOM from 'react-dom';
import { Container } from './style';

export const Loader = () => {
  return ReactDOM.createPortal(<Container>
    <div className='loader' />
  </Container>, document.body);
};
